import { HttpStatusCode } from 'axios'
import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useAuthGDriveAccountAccountApi } from 'api/storageAccount/mutations/useAuthGDriveAccountAccountApi'
import { ApiQueryKeys } from 'constants/apiQueryKeys'
import { LoadingPage } from 'layout/loadingPage/LoadingPage'
import { queryClient } from 'providers/osQueryClient/utils'
import { useToast } from 'providers/toast/ToastProvider'
import { routesManager } from 'utils/routesManager'
import { useGoogleAuthParams } from 'utils/storageAccount'

export const GoogleAuthCallback = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { enqueueToast } = useToast()
  const { authCode, redirectUri } = useGoogleAuthParams()
  const { mutateAsync: authorizeGDrive } = useAuthGDriveAccountAccountApi()
  const userProfileUrl = routesManager.user.profile.url()

  const handleRedirect = useCallback(async (): Promise<void> => {
    if (!authCode || !redirectUri) {
      navigate(userProfileUrl)
      return
    }
    try {
      const response = await authorizeGDrive({ authCode, redirectUri })
      if (response.status === HttpStatusCode.NoContent) {
        queryClient.resetQueries({ queryKey: [ApiQueryKeys.STORAGE_GDRIVE_AUTH] })
        enqueueToast({
          message: t('os.user_profile.integrations.gdrive.connect_toast_success'),
          type: 'success',
        })
      } else {
        enqueueToast({
          message: t('os.common.errors.general'),
          type: 'error',
        })
      }
    } catch (error) {
      enqueueToast({
        message: t('os.common.errors.general'),
        type: 'error',
      })
      navigate(userProfileUrl)
    }

    navigate(userProfileUrl)
  }, [authCode, authorizeGDrive, enqueueToast, navigate, redirectUri, t, userProfileUrl])

  useEffect(() => {
    handleRedirect()
  }, [handleRedirect])

  return <LoadingPage />
}
